module.exports = "//static.hsappstatic.net/HubspotToolsMenu/static-1.128/css/toolsmenu.css"